/*** IMPORTS FROM imports-loader ***/
var define = false;

// Set a variable to get the actual screen height
(function ($, window, document, undefined) {
  var mobileSizing = function () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
  $(document).ready(function () {
    mobileSizing();
  });
  $(window).on("resize orientationchange", function () {
    mobileSizing();
  });
})(jQuery, window, document);
